<template>
  <button 
    :class="buttonClass"
    @click="handleClick"
    :disabled="disabled"
    :title="title"
  >
    <font-awesome-icon :icon="icon" :class="iconClass" />
    {{ text }}
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { useSmartNavigation } from '@/services/navigation'

const props = defineProps({

  variant: {
    type: String,
    default: 'outline-secondary',
    validator: (value) => [
      'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark',
      'outline-primary', 'outline-secondary', 'outline-success', 'outline-danger', 
      'outline-warning', 'outline-info', 'outline-light', 'outline-dark'
    ].includes(value)
  },
  size: {
    type: String,
    default: '',
    validator: (value) => ['', 'sm', 'lg'].includes(value)
  },
  

  text: {
    type: String,
    default: 'Zurück'
  },
  icon: {
    type: String,
    default: 'arrow-left'
  },
  iconClass: {
    type: String,
    default: 'me-1'
  },
  

  fallback: {
    type: String,
    default: '/'
  },
  fallbackParams: {
    type: Object,
    default: () => ({})
  },
  fallbackQuery: {
    type: Object,
    default: () => ({})
  },
  preserveQuery: {
    type: Boolean,
    default: false
  },
  

  customHandler: {
    type: Function,
    default: null
  },
  

  disabled: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['click', 'beforeNavigate', 'afterNavigate'])

const { goBack } = useSmartNavigation()

const buttonClass = computed(() => {
  const classes = ['btn']
  
  if (props.variant) {
    classes.push(`btn-${props.variant}`)
  }
  
  if (props.size) {
    classes.push(`btn-${props.size}`)
  }
  
  return classes.join(' ')
})

const handleClick = () => {
  emit('click')
  emit('beforeNavigate')
  
  if (props.customHandler) {
    props.customHandler()
  } else {
    goBack({
      fallback: props.fallback,
      fallbackParams: props.fallbackParams,
      fallbackQuery: props.fallbackQuery,
      preserveQuery: props.preserveQuery
    })
  }
  
  emit('afterNavigate')
}
</script>
